export default __webpack_public_path__ + "static/media/ggg.a224a927.jpg";